import { Button, Typography } from "@suraasa/placebo-ui"
import { Check } from "iconoir-react"
import React from "react"

const PronunciationSuccess = ({
  onNext,
  onRetry,
}: {
  onNext: () => void
  onRetry: () => void
}) => {
  return (
    <div className="flex flex-col items-center gap-2">
      <div className="grid size-[54px] place-items-center rounded-full bg-success-100 text-success-700 sm:size-10">
        <Check className="size-[30px] sm:size-6" strokeWidth={2.5} />
      </div>
      <Typography className="text-title1Mobile">Great Effort!</Typography>
      <div className="flex w-full max-w-[516px] flex-col items-center gap-1 rounded-lg bg-highlight-50 p-2.5 text-center">
        <Typography variant="strong">You’ve completed this activity</Typography>
        <Typography>
          You can continue to the next module or retry for a better result.
        </Typography>
        <div>
          <Button
            color="black"
            onClick={onRetry}
            size="sm"
            className="mr-1.25 border border-onSurface-300 bg-white text-onSurface-900 shadow-[0px_4px_4px_0px_#0F172A05,0px_1px_1px_0px_#0F172A0A]"
          >
            Retry
          </Button>
          <Button onClick={onNext} size="sm" color="black">
            Next
          </Button>
        </div>
      </div>
    </div>
  )
}

export default PronunciationSuccess
